import React, { useEffect, useCallback, useState} from 'react';
import ipfs from "decentralized/Ipfs.js";
import {
    midiEffectOptions,
    midiConditionalOptions,
    effectOptions,
    initializeEffect,
    initializeMidiEffect
}  from 'components/effects/constants.js';
import {
    setBulkEffectsCollapsed,
    setWindowPosition} from 'actions/index.js';
import {newEffectPreset, getEffectPresets} from "decentralized/effects/EffectPresets.js";
import ContextMenu from "components/dropdowns/ContextMenu.js";
import MenuItem from "components/dropdowns/MenuItem.js";
import SubMenu from "components/dropdowns/SubMenu.js";
import {connect} from 'react-redux';

const AudioFXMenu = ({
    setWindowPosition,
    setBulkEffectsCollapsed,
    effect,
    initializeEffect,
    effectOptions,
    outputNumber,
    addToBack=true,
    dropdownPosRef,
    node,
    sequencerEngine=node.sequencerEngine,
    dropdownPos,
    scale,
    setDropdownPos,
    isMidi
}) => { 
    const [presets, setPresets] = useState([]);

    useEffect(() => {
        getEffectPresets(isMidi ? "Midi Effect Rack" : "Effect Rack").then(
            x => {
                let presets = [];
                for (let preset of x) {
                    presets.push({
                        label: preset.title,
                        value: preset
                    });
                }
                setPresets(presets);
            });
    }, []);

    const initRack = useCallback(() => {
        let rack = initializeEffect("Midi Effect Rack", node);
        node.midiEffects.addEffect(rack);
        return rack;
    }, [node]);

    const addEffect = useCallback((value) => {
        let rack = node.effectRack;
        if (isMidi) {
            let track = node;
            let midiFx = track.midiEffects.effects;
            rack = midiFx.find(e => e.name === "Midi Effect Rack");
            if (!rack) {
                rack = initRack();
            }
        }
        let fx = initializeEffect(value, isMidi ? node : sequencerEngine);
        if (!rack.x) {
            rack.x = dropdownPosRef.current.x - 150;
            rack.y = dropdownPosRef.current.y;
            rack.outputNode.x = dropdownPosRef.current.x + 350;
            rack.outputNode.y = dropdownPosRef.current.y;
        }
        fx.x = dropdownPosRef.current.x;
        fx.y = dropdownPosRef.current.y;
        setWindowPosition(fx.id, {x: fx.x, y: fx.y});
        fx.needsPlacement = true;
        node.addRackEffect(fx, addToBack, effect, outputNumber);
        setDropdownPos(undefined);
    }, [node, dropdownPos, setDropdownPos]);

    const savePreset = useCallback((e) => {
        let name = window.prompt("Preset name");
        let json = node.effectRack.getJson();
        newEffectPreset(json, name);
    }, [node]);

    const loadPreset = useCallback(async (value) => {
        let {effectRack} = node;
        if (!effectRack) {
            effectRack = initRack();
        }
        let effects = [... effectRack.effects];
        effectRack.clearRack();
        let {effectHash} = value;
        let json = await ipfs.getJson(effectHash);
        node.updateEffectRedux([]);
        await effectRack.fromJson(json, node.sequencerEngine.tracks, 0, true, false);
        if (!isMidi) {
            node.linkEffectRackContext();
        }
        let collapsed = {};
        effectRack.effects.forEach(
            e => collapsed[e.id] = true);

        effectRack.x = dropdownPosRef.current.x - 350;
        effectRack.y = dropdownPosRef.current.y - 100;

        setBulkEffectsCollapsed(collapsed);
        /*
        effectRack.effects.forEach(
            e => {
                e.x = effectRack.x + e.x;
                e.y = effectRack.y + 2*e.y - 300;
            });
            */

        let maxX = Math.max(... effectRack.effects.map(e => e.x));
        effectRack.outputNode.x = maxX + 100;
        effectRack.outputNode.y = dropdownPosRef.current.y;
        node.updateEffectRedux();
    }, [node]);

    return (
          <ContextMenu dropdownPos={dropdownPos ? {
              x: dropdownPos.x / scale,
              y: dropdownPos.y / scale } : undefined}>
            <SubMenu name="Presets">
              <MenuItem className="save-preset-item" onClick={savePreset}>
                <div>Save Preset</div>
                <img src="/floppy-disk.svg" className="save-preset-icon"/>
              </MenuItem>
              {presets.map(
                  ({label, value})  =>
                      <MenuItem
                        onMouseDown={() => loadPreset(value)}
                      >
                        {label}
                      </MenuItem>)}
            </SubMenu>
        {isMidi ?
         <div>
           <SubMenu name="Standard Midi FX">
             <div>
              {midiEffectOptions.map(
                  ({label, value})=>
                      <MenuItem
                        onMouseDown={() => addEffect(value)}
                      >{label}</MenuItem>)}
             </div>
           </SubMenu>
           <SubMenu name="Flow Midi FX">
             <div>
              {midiConditionalOptions.map(
                  ({label, value})=>
                      <MenuItem
                        onMouseDown={() => addEffect(value)}
                      >{label}</MenuItem>)}
             </div>
           </SubMenu>
         </div>
         :
            <div className="fx-options">
              {effectOptions.map(
                  ({label, value})=>
                      <MenuItem
                        onMouseDown={() => addEffect(value)}
                      >{label}</MenuItem>)}
            </div>}
          </ContextMenu>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setBulkEffectsCollapsed: x => dispatch(
          setBulkEffectsCollapsed(x)),
      setWindowPosition: (id,pos) => dispatch(
          setWindowPosition(id, pos))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AudioFXMenu);
